import { defaultsCardholderAdditionalBenefits } from "./defaults";
import { CardholderBenefitsModel } from "./types";
import {
  CardApplicationDocument,
  CardholderBenefitsDto,
} from "../../api/commercial/generated-types";

const mapDocumentToPageModel = (
  document: CardApplicationDocument,
): CardholderBenefitsModel => {
  const resultCardholderBenefits = document.milesAndMore;
  return resultCardholderBenefits
    ? {
        customerNumber: resultCardholderBenefits.customerNumber,
        isCardholderLoyaltyParticipant: resultCardholderBenefits.customerNumber
          ? "yes"
          : "no",
      }
    : defaultsCardholderAdditionalBenefits;
};

const mapPageModelToRequest = (
  data: CardholderBenefitsModel,
): CardholderBenefitsDto => {
  return {
    customerNumber:
      data.isCardholderLoyaltyParticipant === "yes"
        ? data.customerNumber
        : null,
  };
};

const CardholderBenefitsMapper = {
  mapPageModelToRequest,
  mapDocumentToPageModel,
};

export default CardholderBenefitsMapper;
